export const DEFAULT_URL = 'https://app.happyreact.com';
